import _ from '../../../util/underscore-wrapper';
import Logger from '../../../util/Logger';
import Util from '../../../util/Util';
import StringUtil from '../../../util/StringUtil';
import BaseView from '../../BaseView';
import hbs from 'handlebars-inline-precompile';

const isABaseView = Util.isABaseView;
/**
 * @class InputContainer
 * @private
 *
 * TODO: OKTA-80796
 * Attention: Please change with caution since this is used in other places
 */

export default BaseView.extend({
  attributes: function () {
    return {
      'data-se': 'o-form-input-container'
    };
  },

  className: function () {
    let className = 'o-form-input';

    if (this.options.wide) {
      className += ' o-form-wide';
    }
    if (_.contains([1, 2, 3, 4], this.options.multi)) {
      className += ' o-form-multi-input-' + this.options.multi;
      if (_.isArray(this.options.input)) {
        const inputGroup = _.find(this.options.input, function (input) {
          return _.contains(['text+select', 'select+text'], input.options.type);
        });

        inputGroup && (className += ' o-form-multi-input-group-' + this.options.multi);
      }
    }
    return className;
  },

  _getNames: function () {
    const names = _.isArray(this.options.name) ? this.options.name : [this.options.name];
    /*eslint complexity: 0 */

    if (this.options.type === 'group') {
      names.push.apply(names, _.pluck(this.options.input[0].options.params.inputs, 'name'));
    } else if (_.isArray(this.options.name)) {
      if (this.options.input && this.options.input.options && this.options.input.options.name) {
        names.push(this.options.input.options.name);
      }
    } else if (this.options.input) {
      if (_.isArray(this.options.input)) {
        _.each(this.options.input, function (inputItem) {
          names.push(inputItem.options.name);
        });
      } else {
        names.push(this.options.input.options.name);
      }
    }
    return _.uniq(_.compact(names));
  },

  constructor: function () {
    /* eslint max-statements: [2, 18] */
    BaseView.apply(this, arguments);

    const explainTop = this.options['explain-top'] && this.options['label-top'];
    if (this.options.input) {
      if (_.isArray(this.options.input)) {
        _.each(
          this.options.input,
          function (inputItem) {
            this.add(inputItem, { prepend: !explainTop });
          },
          this
        );
      } else {
        this.add(this.options.input, { prepend: !explainTop });
      }
    }

    this.__setExplain(this.options);

    const names = this._getNames();

    this.listenTo(this.model, 'form:field-error', function (name, errors) {
      if (_.contains(names, name)) {
        this.__setError(errors, explainTop);
      }
    });

    this.listenTo(this.model, 'form:clear-errors change:' + names.join(' change:'), this.__clearError);
    this.listenTo(this.model, 'form:clear-error:' + names.join(' form:clear-error:'), this.__clearError);

    if (_.resultCtx(this.options, 'autoRender', this)) {
      this.listenTo(this.model, 'change:' + this.options.name, this.render);
    }

    this.__errorState = false;
  },

  /**
   * Populates the explain on the input container (if it exists). There are
   * two ways to use this:
   * 1. Raw text - wraps in the correct html template
   * 2. Custom html
   *    - pass in a View class (preferred)
   *    - pass in an instance of a View
   * Some additional notes:
   * - You can pass a function that returns any of the above
   * - This maintains support for the deprecated "customExplain" property
   *   that was used before. This pattern is superseded by explain, so use
   *   that instead.
   * @private
   */
  __setExplain: function (options) {
    let explain;

    // Deprecated - if you need custom html, use explain instead
    if (options.customExplain) {
      Logger.warn('Deprecated - use explain instead of customExplain');
      this.add(this.options.customExplain);
      return;
    }

    explain = options.explain;
    if (_.isFunction(explain) && !isABaseView(explain)) {
      explain = _.resultCtx(this.options, 'explain', this);
    }
    if (!explain) {
      return;
    }

    if (isABaseView(explain)) {
      this.template = hbs('<p class="o-form-explain"></p>');
      this.add(explain, '.o-form-explain');
    } else {
      this.template = hbs('<p class="o-form-explain">{{explain}}</p>');
    }
  },

  /**
   * Highlight the input as invalid (validation failed)
   * Adds an explaination message of the error
   * @private
   */
  __setError: function (errors, explainTop) {
    this.__errorState = true;
    this.$el.addClass('o-form-has-errors');

    const errorId = _.uniqueId('input-container-error');
    const tmpl = hbs`
      <p id="{{errorId}}" class="okta-form-input-error o-form-input-error o-form-explain" role="alert">
      <span class="icon icon-16 error-16-small" role="img" aria-label="{{iconLabel}}"></span>{{text}}</p>
    `;

    const iconLabel = StringUtil.localize('oform.error.icon.ariaLabel', 'courage'); // 'Error'
    const html = tmpl({
      errorId: errorId,
      iconLabel: iconLabel,
      text: errors.join(', ')
    });

    const $elExplain = this.$('.o-form-explain')
      .not('.o-form-input-error')
      .first();

    if ($elExplain.length && !explainTop) {
      $elExplain.before(html);
    } else {
      this.$el.append(html);
    }

    this.$el.attr('aria-describedby', errorId);
  },

  /**
   * Un-highlight the input and remove explaination text
   * @private
   */
  __clearError: function () {
    if (this.__errorState) {
      this.$('.o-form-input-error').remove();
      this.$el.attr('aria-describedby', null);
      this.$el.removeClass('o-form-has-errors');
      this.__errorState = false;
      _.defer(() => {
        this.model.trigger('form:resize');
      });
    }
  },

  focus: function () {
    this.each(function (view) {
      if (view.focus) {
        return view.focus();
      }
    });

    return this;
  }
});



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/views/forms/helpers/InputContainer.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/views/forms/helpers/InputContainer.js